export const CREATE_SALES_SAVE_FILTER = "CREATE_SALES_SAVE_FILTER";
export const GET_SALES_SAVE_FILTER = "GET_SALES_SAVE_FILTER";
export const DELETE_SALES_SAVE_FILTER = "DELETE_SALES_SAVE_FILTER";
export const UPDATE_SALES_SAVE_FILTER = "UPDATE_SALES_SAVE_FILTER";
export const GET_SALES_SHARE_FILTER = "GET_SALES_SHARE_FILTER";
export const CREATE_SALES_SHARE_FILTER = "CREATE_SALES_SHARE_FILTER";
export const REMOVE_SALES_SHARE_FILTER = "REMOVE_SALES_SHARE_FILTER";

export const CREATE_SERVICES_SAVE_FILTER = "CREATE_SERVICES_SAVE_FILTER";
export const GET_SERVICES_SAVE_FILTER = "GET_SERVICES_SAVE_FILTER";
export const DELETE_SERVICES_SAVE_FILTER = "DELETE_SERVICES_SAVE_FILTER";
export const UPDATE_SERVICES_SAVE_FILTER = "UPDATE_SERVICES_SAVE_FILTER";
export const GET_SERVICES_SHARE_FILTER = "GET_SERVICES_SHARE_FILTER";
export const CREATE_SERVICES_SHARE_FILTER = "CREATE_SERVICES_SHARE_FILTER";
export const REMOVE_SERVICES_SHARE_FILTER = "REMOVE_SERVICES_SHARE_FILTER";

export const CREATE_ESCALATIONS_SAVE_FILTER = "CREATE_ESCALATIONS_SAVE_FILTER";
export const GET_ESCALATIONS_SAVE_FILTER = "GET_ESCALATIONS_SAVE_FILTER";
export const DELETE_ESCALATIONS_SAVE_FILTER = "DELETE_ESCALATIONS_SAVE_FILTER";
export const UPDATE_ESCALATIONS_SAVE_FILTER = "UPDATE_ESCALATIONS_SAVE_FILTER";
export const GET_ESCALATIONS_SHARE_FILTER = "GET_ESCALATIONS_SHARE_FILTER";
export const CREATE_ESCALATIONS_SHARE_FILTER = "CREATE_ESCALATIONS_SHARE_FILTER";
export const REMOVE_ESCALATIONS_SHARE_FILTER = "REMOVE_ESCALATIONS_SHARE_FILTER";